
import { QuickOrderAdditionalFee } from '../types';
import { api } from './api';

export type QuickOrderAdditionalFeeCreatePayload = Pick<QuickOrderAdditionalFee, 'name' | 'price' | 'quickOrderId' | 'description' | 'type'>;

export const quickOrderAdditionalFeesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		createQuickOrderAdditionalFee: builder.mutation<QuickOrderAdditionalFee, QuickOrderAdditionalFeeCreatePayload>({
			query: (data: Pick<QuickOrderAdditionalFee, 'name' | 'price' | 'quickOrderId' | 'description'>) => ({
				url: '/quickOrderAdditionalFees',
				method: 'POST',
				body: data,
			}),
		}),
		deleteQuickOrderAdditionalFee: builder.mutation<Pick<QuickOrderAdditionalFee, 'id'>, number>({
			query: (id: number) => ({
				url: `/quickOrderAdditionalFees/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const { useCreateQuickOrderAdditionalFeeMutation, useDeleteQuickOrderAdditionalFeeMutation } = quickOrderAdditionalFeesApi; 
